export default {
    // ========== Field labels ==========
    equivalentWeighting: 'Equivalent weighting',
    lockRaMicroCreation: 'Lock {entity} creation in {context}',
    selectableIn: 'Is selectable in',
    matterCategory: 'Matter category',
    defaultLanguage: 'Subject language',
    noDefaultLanguage: 'Select a language',
    defaultLanguagePopoverTitle: 'Views affected by the language',
    defaultLanguagePopoverDesc: 'When a language is set for the subject, the following views will be displayed in that language for users who access them.',
    defaultLanguagePopoverAllInstitutions: 'Available for all institutions',
    defaultLanguagePopoverDuocOnly: 'DUOC UC only',
    defaultLanguagePopoverEvaluateeNote: 'When answering or reviewing an evaluation',
    defaultLanguageViewsTitle: 'Views where the language will change',
    defaultLanguageViewEval: 'View of {name}',
    defaultLanguageTeacherView: "Teacher's View in {name}",
    defaultLanguageStudentView: "Student's View in {name}",
    defaultLanguageOutputFormat: 'Output Format {name}',
    defaultLanguageOutputLearningExp: 'Output Format Learning Experiences',
    defaultLanguageOutputSubjectDesc: 'Output Format Subject Description',
    defaultLanguageOutputPA: 'Output Format PA',
    defaultLanguageOutputPDA: 'Output Format PDA',
    defaultLanguageOutputPIA: 'Output Format PIA',
    planLevel: 'Plan level',
    isCapstoneCourse: 'Integrative Matter',
    weeks: 'Weeks',
    students: 'Students',
    teachers: 'Teachers',
    assistants: 'Assistants',

    // ========== Actions ==========
    automatic: 'Automatic',
    planned: 'Planned',
    lock: 'Lock',
    unlock: 'Unlock',

    // ========== Tooltips and messages ==========
    changesReflectedTooltip: 'Changes to this field will be reflected in all linked {entity}',
    changesReflectedTooltip2: 'Changes to this field will be reflected in all {entity}',
    markedFieldsChangesTooltip: 'Changes in marked fields (⚠️) will be reflected in all {entity1} linked to this {entity2}.',
    useEquivalentWeightingTooltip: 'Use an equivalent weighting for {entity1} and {entity2}',
    enableRaMicroCreationTooltip: 'Enables the creation of {entity} directly in {context}.',
    enableHoursDistributionTooltip: 'Enables the distribution of {entity} hours among assigned teacher profiles. If disabled, hours can be freely assigned to each teacher without exceeding the total allowed.',
    allowRaAssignmentTooltip: 'Allows the assignment of a {entity1} already related to another {entity2}.',
    evaluationErrorsPopover: 'The {entity} has some errors in the evaluations that must be corrected. For more information, press the button.',
    changeStatusTooltip: 'Change the status of the {entity}',
    changeStatusOf: 'Change the status of the {entity}',

    lockDescriptorsTooltip: '<b>Lock descriptors</b> <br> This will prevent users without permission from modifying data within {entity}',
    unlockDescriptorsTooltip: '<b>Unlock descriptors</b> <br> This will allow users to modify data within {entity}',

    lockTeachingSupportTooltip: '<b>Lock Teaching support resources</b> <br> This will prevent users without permission from modifying data within {entity}',
    unlockTeachingSupportTooltip: '<b>Unlock Teaching support resources</b> <br> This will allow users to modify data within {entity}',

    lockBibliographicResourcesTooltip: '<b>Lock Bibliographic resources</b> <br> This will prevent users without permission from modifying data within {entity}',
    unlockBibliographicResourcesTooltip: '<b>Unlock Bibliographic resources</b> <br> This will allow users to modify data within {entity}',

    lockTeacherProfilesTooltip: '<b>Lock Teacher profile(s)</b> <br> This will prevent users without permission from modifying data within {entity}',
    unlockTeacherProfilesTooltip: '<b>Unlock Teacher profile(s)</b> <br> This will allow users to modify data within {entity}',

    lockAssistantProfilesTooltip: '<b>Lock Assistant profiles</b> <br> This will prevent users without permission from modifying data within {entity}',
    unlockAssistantProfilesTooltip: '<b>Unlock Assistant profiles</b> <br> This will allow users to modify data within {entity}',

    reviewCode: 'Review {entity} for the {context}',

    // ========== Validations ==========
    fieldMinLength: 'This field must not be empty and must not be less than {min} characters.',
    existsWithName: 'There is a {entity} with that name in {context}',
    cannotCreateBelongsToOther: 'This {entity} cannot be created, as it belongs to another transversal {context}.',
    existsWithSameName: 'There is a {entity} with that name.',
    alreadyBeingUsed: 'This {entity} is already being used.',
    importFromBaseByCodeTitle: '{code_entity} in use',
    importFromBaseByCode: 'This {code_entity} belongs to the {entity} <strong>"{name}"</strong>. Would you like to assign its data into the form?',
    importData: 'Assign {entity}',
    fieldGreaterThanAndLessOrEqual: 'This field must be greater than {min} and less than or equal to {max}',
    mustSelectEntityForEntity: 'You must select a {entity1} for the {entity2}.',

    // ========== Modals and messages ==========
    selectToUse: 'Select the {entity} to assign',
    selectCategory: 'Select a category.',
    noCategoriesCreated: 'There are no Categories created',

    // ========== Number of fields ==========
    numberOf: 'No {entity}',
    defineNumberInStudyPlan: 'Defines the number of the {entity} in the Study Plan.',

    // ========== Actions with entities ==========
    selectEntity: 'Select {entity}',
    selectBaseDescription: 'If you wish to use a {entity} as a reference, you can select it below. Some of its data will be automatically assigned in this form.',
    linkEntity: 'Vink {entity}',
    clearNameAndEntity: 'Clear name and {entity}',

    // ========== Availability messages ==========
    verifyEntityAvailable: 'verify that the {entity} is available on the platform',
    occupied: 'occupied',

    // ========== Weighting and evaluation messages ==========
    cannotChangeWeightingClosedEvaluations: 'Cannot change Equivalent Weighting as there are already closed evaluations. If you still want to change the Weighting, press the button and open the Evaluations that will be indicated in the window',

    // ========== Hours distribution ==========
    distributeCoTeachingHours: 'Distribute co-teaching hours',
    distributeTeacherProfileHours: 'Distribute Teacher Profile hours',

    // ========== Calculations and formulas ==========
    hoursPerCredit: 'Hours per',
    necessaryForRegistration: 'Necessary for registration in {entity}',
    necessaryForShow: 'Required so that it can appear for selection in {entity}',
    changeWeeksWarning: 'Changing the number of weeks will modify the total amount of {entity1} and {entity2}.',
    shares: 'Shares',
    isExemptable: 'Exemptable',

    // ========== Navigation and redirection ==========
    goToCurricularDefinitions: 'Go to Curricular Definitions to create {entity}',

    // ========== States and information ==========
    informationToComplete: 'Information to Complete',
    closedEvaluations: 'Closed Evaluations',
    currentlyEntityLocked: 'Currently the {entity} are locked',

    // ========== Tabs and sections ==========
    descriptors: 'Descriptors',
    teachingSupportResources: 'Teaching support resources',
    bibliographicResources: 'Bibliographic resources',
    teacherProfiles: 'Teacher profile(s)',
    assistantProfiles: 'Assistant profile(s)',

    // ========== Confirmations and alerts ==========
    notAssignedAnyEntity: 'taking into account that you have not assigned any {entity}',
    sureToCloseEntity: 'Are you sure you want to close the {entity}?',
    assignPrerequisitesMessage: 'To assign prerequisites from the <strong>Transversal {entity1}</strong>, you must first create the following <strong>{entity2}:</strong> "<strong>{matters}</strong>"',
    alreadyHasEntityInProfile: 'This {entity1} already has the selected {entity2} in "{wrapper}".',
    alreadyHasEntitySelected: 'This {entity1} already has the selected {entity2}.',

    // ========== Link Base Matter Popover ==========
    linkEntityPopoverTitle: 'What does linking the {entity} mean?',
    linkEntityLinkedTitle: 'Linked (Yes)',
    linkEntityLinkedDesc: 'The {entity1} in the {entity2} takes and shares data from the {entity3}.',
    linkEntityLinkedItems: 'Hours and time allocations|Credits and institutional credits|Weeks|Modalities and study environments|Matter types|Descriptors|Evaluations',
    linkEntityLinkedWarning: 'Changes affect ALL {entity} that use the same base and are linked.',
    linkEntityIndependentTitle: 'Not linked (No)',
    linkEntityIndependentDesc: 'The {entity1} will have its own independent values in the {entity2}.',
    linkEntityIndependentItems: 'Own hours and time allocations|Credits calculated from own hours|Own weeks|Own modalities and environments|Own matter types|Own descriptors|Own evaluations',
    linkEntityIndependentInfo: 'Changes only affect this {entity1} in this {entity2}.',
    linkEntityCopyNote: 'When unlinking, the current base values are copied as a starting point.',
    linkEntityAlwaysOwnTitle: 'Always specific to the {entity}',
    linkEntityAlwaysOwnDesc: 'The following data is always specific to the {entity1} within its {entity2}, regardless of whether it is linked or not:',
    linkEntityAlwaysOwnItemName: 'Name in the {entity}',
    linkEntityAlwaysOwnItemWeighing: 'Weighing in the curriculum',
    linkEntityAlwaysOwnItemCompetences: 'Competences it contributes to',

    // ========== Data preserved when selecting base matter ==========
    preservedDataTitle: 'Data inherited from the {entity}',
    preservedDataDesc: 'When selecting a {entity}, the following data will be assigned:',

    // ========== OldMatterForm Form ==========
    existingEntity: 'Existing',
    thisEntityDoesNotHave: 'This {entity1} does not have {entity2} created',
    savedSuccessfully: 'Changes saved successfully.',
    createdSuccessfully: '{entity} created successfully.',
    eliminatedSuccessfully: '{entity} deleted.',

    // ========== PUCV credits ==========
    pucvCreditsReference: 'Equivalent to {sct} SCT credits, {weekly_hours} weekly PUCV pedagogical hours (35 min) and up to {hours} per semester.',
    pucvHoursExceeded: 'The total hours ({total} PUCV pedagogical hours) exceed the {max} that correspond to {credits} {entity}.',
    pucvSctMismatch: 'According to PUCV, {credits} {entity} are equivalent to {sct} SCT credits (× 1.5).',
}
